import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M11.8733 11L11 11.8732L18.9811 19.8543L19.8544 18.981L11.8733 11Z' }),
  React.createElement('path', { d: 'M18.9811 11L11 18.9811L11.8733 19.8543L19.8544 11.8733L18.9811 11Z' })
));